import React from 'react';
import { Modal, Button, ListGroup } from 'react-bootstrap';
import Form from 'react-bootstrap/Form';
import PropTypes from 'prop-types';
import Dnaspinner from "../components/UI/Dnaspinner";
class PurchaseReturnSelectModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedBatches: [], // State to track the selected batches
      selectedExpdates:[],
      selectedQuantities:[],
      selectedPrates:[],
      selectedMRPs:[],
      selectedSubtotals:[],
      selectedTotals:[],
      loading:true,
    };
  }

/*   handleCheckboxChange = (event, exp_date) => {
    const { id, checked } = event.target;
    this.setState((prevState) => {
      console.log(prevState);
        if (checked) {
            // Add the batch_no to selectedBatches and exp_date to selectedExpdates if checked
            return {
                selectedBatches: [...prevState.selectedBatches, id],
                selectedExpdates: [...prevState.selectedExpdates, exp_date] // Correctly update selectedExpdates
            };
        } else {
            // Remove the batch_no from selectedBatches and corresponding exp_date from selectedExpdates if unchecked
            return {
                selectedBatches: prevState.selectedBatches.filter(batch_no => batch_no !== id),
                selectedExpdates: prevState.selectedExpdates.filter(date => date !== exp_date) // Remove corresponding exp_date
            };
        }
    }, () => {
        console.log(this.state.selectedBatches);
        console.log(this.state.selectedExpdates); // Log selectedExpdates for debugging
       
        // Call the selectBatch function passed as a prop with the updated selectedBatches
        this.props.selectBatch(this.state.selectedBatches,this.state.selectedExpdates);
        
    });
   
}; */
handleCheckboxChange = (event, exp_date, quantity,p_rate,mrp,sub_total,total) => {
  const { id, checked } = event.target; // Destructure id and checked from the event target
  this.setState((prevState) => {
    let newSelectedBatches = prevState.selectedBatches;
    let newSelectedExpdates = prevState.selectedExpdates;
    let newSelectedQuantities = prevState.selectedQuantities;
    let newSelectedPrates = prevState.selectedPrates;
    let newSelectedMRPs = prevState.selectedMRPs;
    let newSelectedSubtotals = prevState.selectedSubtotals;
    let newSelectedTotals = prevState.selectedTotals;
    if (checked) {
      // If checked, add the new values
      newSelectedBatches = [...prevState.selectedBatches, id];
      newSelectedExpdates = [...prevState.selectedExpdates, exp_date];
      newSelectedQuantities = [...prevState.selectedQuantities, quantity]; // Use the passed quantity
      newSelectedPrates=[...prevState.selectedPrates,p_rate];
      newSelectedMRPs=[...prevState.selectedMRPs,mrp];
      newSelectedSubtotals=[...prevState.selectedSubtotals,sub_total];
      newSelectedTotals=[...prevState.selectedTotals,total];
    } else {
      // If unchecked, remove the values
      newSelectedBatches = prevState.selectedBatches.filter(batch_no => batch_no !== id);
      newSelectedExpdates = prevState.selectedExpdates.filter(date => date !== exp_date);
      newSelectedQuantities = prevState.selectedQuantities.filter(qty => qty !== quantity); // Use the passed quantity
      newSelectedPrates = prevState.selectedPrates.filter(prate => prate !== p_rate); 
      newSelectedMRPs = prevState.selectedMRPs.filter(mp => mp !== mrp); 
      newSelectedSubtotals = prevState.selectedSubtotals.filter(subtotal => subtotal !== sub_total); 
      newSelectedTotals = prevState.selectedTotals.filter(tot => tot !== total); 
    }

    console.log("Selected Batches:", newSelectedBatches);
    console.log("Selected Expdates:", newSelectedExpdates);
    console.log("Selected Quantities:", newSelectedQuantities); // Log the selected quantities

    return {
      selectedBatches: newSelectedBatches,
      selectedExpdates: newSelectedExpdates,
      selectedQuantities: newSelectedQuantities,
      selectedPrates:newSelectedPrates,
      selectedMRPs:newSelectedMRPs,
      selectedSubtotals:newSelectedSubtotals,
      selectedTotals:newSelectedTotals
    };
  }, () => {
    console.log("Final Selected Batches:", this.state.selectedBatches);
    console.log("Final Selected Expdates:", this.state.selectedExpdates);
    console.log("Final Selected Quantities:", this.state.selectedQuantities); // Log the final selected quantities

    // Call the selectBatch function passed as a prop with the updated selected values
    this.props.selectBatch(this.state.selectedBatches, this.state.selectedExpdates, this.state.selectedQuantities,this.state.selectedPrates,this.state.selectedMRPs,this.state.selectedSubtotals,this.state.selectedTotals);
  });
};

handleBatchCheck = (batchNo) => {
  this.setState(prevState => {
      const selectedBatches = prevState.selectedBatches.includes(batchNo)
          ? prevState.selectedBatches.filter(b => b !== batchNo) // Uncheck if already checked
          : [...prevState.selectedBatches, batchNo]; // Check if not checked
      return { selectedBatches };
  });
};



  render() {
    const { show, handleBatchClose, batches,handleSelectBatchClick,loading } = this.props;
    const { selectedBatches } = this.state;

    return (
      <Modal show={show} onHide={handleBatchClose}>
        <Modal.Header closeButton>
          <Modal.Title>Select Batches</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <p>Batch Number  _ Expiry Date   _  Quantity </p>
            {loading ? (
            <Dnaspinner /> // Show the spinner while loading
          ) : (
         <ListGroup>
               {batches.map(batch => (
              <ListGroup.Item key={batch.batch_no}>
                <Form.Check 
                  type="checkbox" 
                  id={batch.batch_no} // Use batch_no as the id
                  label={`${batch.batch_no}\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0${new Date(batch.exp_date).toLocaleDateString('en-US', { month: 'short', year: 'numeric' })}\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0_\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0${batch.quantity<0?0:batch.quantity}`}
                  checked={selectedBatches.includes(batch.batch_no)} // Check if this batch_no is selected
                  onChange={(event) => this.handleCheckboxChange(event, batch.exp_date,batch.quantity,batch.p_rate,batch.mrp,batch.sub_total,batch.total)} 
                />
             
              </ListGroup.Item>
              
            ))}
            </ListGroup>
             )}
        </Modal.Body>
        <Modal.Footer>
     
          <Button variant="secondary" onClick={handleBatchClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}


// PropTypes for validation
PurchaseReturnSelectModal.propTypes = {
  show: PropTypes.bool.isRequired,
  handleBatchClose: PropTypes.func.isRequired,
  batches: PropTypes.arrayOf(
    PropTypes.shape({
      batch_no: PropTypes.string.isRequired,
      exp_date: PropTypes.string.isRequired, // Assuming exp_date is a string in ISO format
    })
  ).isRequired,
  selectBatch: PropTypes.func.isRequired,
};

export default PurchaseReturnSelectModal;